import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiHeart, FiEye, FiShield, FiClock } from 'react-icons/fi';

const features = [
  {
    icon: FiEye,
    title: "The Gaze of Devotion",
    description: "Learn how to read the subtle changes in eye contact that reveal a depth of emotion words cannot capture."
  },
  {
    icon: FiShield,
    title: "Protective Instincts",
    description: "Understand the quiet, everyday actions he takes to ensure your safety and comfort without ever mentioning it."
  },
  {
    icon: FiClock,
    title: "The Gift of Time",
    description: "Discover why his presence and the way he prioritizes his schedule is the ultimate declaration of love."
  },
  {
    icon: FiHeart,
    title: "Unspoken Commitments",
    description: "Decode the small, consistent behaviors that build a foundation of unbreakable trust and romance."
  }
];

const BookDetails = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-5xl font-serif font-bold text-stone-900 mb-6"
          >
            Beyond Words: Decoding His Heart
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg text-stone-600 leading-relaxed"
          >
            Society often tells us that romance is loud — grand gestures, expensive gifts, and poetic declarations. But true, enduring romance is often quiet. It exists in the spaces between words. This book reveals the 8 undeniable signs that he is deeply, romantically in love with you, even if he rarely says it.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="p-8 rounded-2xl bg-stone-50 border border-stone-100 hover:shadow-lg transition-shadow duration-300 group"
            >
              <div className="w-14 h-14 bg-brand-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-brand-200 transition-colors">
                <SafeIcon icon={feature.icon} className="w-6 h-6 text-brand-700" />
              </div>
              <h3 className="text-xl font-serif font-bold text-stone-900 mb-3">{feature.title}</h3>
              <p className="text-stone-600 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-20 p-8 md:p-12 bg-stone-900 rounded-3xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-500/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
          <div className="relative z-10 md:flex items-center justify-between">
            <div className="max-w-2xl mb-8 md:mb-0">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-4">
                Ready to understand him completely?
              </h3>
              <p className="text-stone-300 text-lg">
                Stop second-guessing and start seeing the profound romance in his everyday actions.
              </p>
            </div>
            <button
              onClick={() => document.getElementById('get-copy').scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-white text-stone-900 rounded-full hover:bg-brand-50 transition-colors font-medium whitespace-nowrap"
            >
              Read the First Chapter
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookDetails;